import { useEffect, useRef } from 'react'
import { MdLibraryAddCheck } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import { MdLibraryAdd } from "react-icons/md";
import { useAuth0 } from '@auth0/auth0-react'
import './surah.scss'
import { SurahType } from '../../utils/types'
import { useSurah } from '../../hooks/useSurah'
import { usePlaylist } from '../../hooks/usePlaylist'
import { addZeros } from '../../utils/addZeros';
import { useDownload } from '../../hooks/useDownload';
import { useTranslation } from '../../hooks/useTranslation';

export const Surah = ({ surah }: { surah: SurahType }) => {
    const card = useRef<HTMLInputElement>(null);

    const { addSurahToPlaylist, removeSurahToPlaylist, isInPlaylist: isInPlaylistFn } = usePlaylist()
    const { isAuthenticated, } = useAuth0();
    const { checkDownload, downloadSurah } = useDownload()
    const { setCurrentSurah, currentSurah } = useSurah()
    const { lang } = useTranslation();

    const isCurrentSurah = surah.id === currentSurah.id

    const downloadProgress = checkDownload(surah.id)

    // isInPlaylist
    const isInPlaylist = isInPlaylistFn(surah.id)
    // on click to Surah
    const handleChangeSurah = () => {
        setCurrentSurah(surah)
    }
    // Scroll to current Surah
    useEffect(() => {
        if (isCurrentSurah && card.current) {
            window.scrollTo({ top: card.current.offsetTop, behavior: 'smooth' })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSurah])
    // add to playlist
    const addToPlaylist = async (e: any) => {
        e.stopPropagation()
        await addSurahToPlaylist({ surah })
    }
    // remove from playlist
    const removeFromPlaylist = async (e: any) => {
        e.stopPropagation()
        await removeSurahToPlaylist({ surahId: surah.id })
    }
    // download Surah
    const downloadSurahFn = async () => {
        await downloadSurah({ surah })
    }

    return (
        <div ref={card}
            className={`surah ${isCurrentSurah ? 'activeSurah' : ''}`}
            dir={lang === 'ar' ? 'rtl' : 'ltr'}
            onClick={handleChangeSurah} >
            <h3>{addZeros({ number: surah.surahNumber, numOfZeros: 3 })}</h3>
            <div className="authorImage" style={{ backgroundImage: `url(${surah.photo})` }}></div>
            <div className="body">
                <h3 className={lang === 'en' ? 'title' : 'arabic-font title'}>
                    {lang === 'en' && surah.titleEn ? surah.titleEn : surah.title}
                </h3>
                <p className={lang === 'en' && surah.quranReciterEn ? 'author' : 'arabic-font author'}>
                    {lang === 'en' && surah.quranReciterEn ? surah.quranReciterEn : surah.quranReciter}
                </p>
            </div>
            <div className="option">
                {isAuthenticated && (
                    <div
                        className={`icon-btn${isInPlaylist ? ' icon-btn--added' : ''}`}
                        onClick={isInPlaylist ? removeFromPlaylist : addToPlaylist}
                    >
                        {isInPlaylist
                            ? <MdLibraryAddCheck size={20} />
                            : <MdLibraryAdd size={20} />
                        }
                    </div>
                )}
                {downloadProgress ? (
                    <div className='downloadProgress'>
                        <h3 className='step'>
                            %{addZeros({ number: Math.trunc(downloadProgress.step), numOfZeros: 2 })}
                        </h3>
                        <div className='mb'>{downloadProgress.totalMb}MB</div>
                    </div>
                ) : (
                    <div className="icon-btn icon-btn--download" onClick={(e) => { e.stopPropagation(); downloadSurahFn(); }}>
                        <FaDownload size={18} />
                    </div>
                )}
            </div>
            {
                surah.surahPlayedCount ?
                    <div className='surahPlayedCount'>
                        {surah.surahPlayedCount} views
                    </div>
                    : <></>
            }
        </div >
    )
}
